import { toast } from "react-hot-toast";

export const notify = (message, options) => {
  options = options || {};
  options.type = options.type || 'custom';
  options.position = 'top-right';

  return toast[options.type](message, options);
};
